import { map, mergeDeepRight } from 'ramda'

const pages = [
  /* 首页 */
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "video-clip-index" */ '@/views/live-slice/home'),
    meta: {
      scrollToTop: true,
      redirectH5PageName: 'h5-video-clip-home'
    }
  },
  /* 达人广场 */
  {
    path: '/danda-square',
    name: 'danda-square',
    component: () => import(/* webpackChunkName: "danda-square" */ '@/views/live-slice/danda-square.vue'),
    meta: {
      scrollToTop: true,
      redirectH5PageName: 'h5-video-clip-choose-author'
    }
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404/index'),
    index: '999',
    requireLogin: false,
    beforeEnter: (route, redirect, next) => {
      console.log(route)
      next()
    }
  },
  {
    path: '*', // 此处需特别注意置于最底部
    redirect: '/404'
  }
]

export default pages |> map(mergeDeepRight({ meta: { requireLogin: false } }))
